import { InfiniteData, useQuery, useQueryClient } from '@tanstack/react-query';
import { apolloClient } from '@client/api/graphql/client';
import {
  GetCommunityPostDocument,
  GetCommunityPostQuery,
  GetCommunityPostQueryVariables,
  Post,
} from '../../../../generated/graphql';
import { communityQueryKeys } from '../constants';

export const useCommunityPost = (communityId: number, postId: string) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: communityQueryKeys.post(communityId, postId),
    queryFn: async (): Promise<Post | undefined> => {
      const response = await apolloClient.query<
        GetCommunityPostQuery,
        GetCommunityPostQueryVariables
      >({
        query: GetCommunityPostDocument,
        variables: { communityId, postId },
        fetchPolicy: 'network-only',
      });
      return response.data.post ?? undefined;
    },
    initialData: () => {
      const cache = queryClient.getQueryData<InfiniteData<Post[] | undefined>>(
        communityQueryKeys.posts(communityId),
      );
      return cache?.pages.flat().find((p) => p?.id === postId);
    },
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};
